export { P70FindStoresPage as default } from './components/P70FindStores';
